import {Component, Input} from '@angular/core';
import {WidgetModel} from '../../../model/widget.model';

@Component({
    selector: 'app-etf-contract-filter-widget-settings',
    templateUrl: './etf-contract-filter-widget.settings.component.html',
    styleUrl: './etf-contract-filter-widget.settings.component.scss'
})
export class AppContractFilterWidgetSettingsComponent {
    @Input() widget: WidgetModel;
}